"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var User = function User(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M7.812 16.56c1.846-.609 2.29-1.206 2.315-2.84a3.051 3.051 0 01-.492-.49 3.801 3.801 0 01-.7-1.864.351.351 0 01-.086.011c-.34 0-.596-.832-.596-1.417 0-.585.174-.763.34-.763.044 0 .088.004.132.01a5.797 5.797 0 01-.16-1.263c0-2.188.834-3.438 3.438-3.438 1.24 0 1.324.326 1.563.782a.72.72 0 01.468-.157c.663 0 1.407.85 1.407 2.813-.007.425-.06.849-.16 1.263a.948.948 0 01.132-.01c.166 0 .34.178.34.763s-.256 1.417-.595 1.417a.35.35 0 01-.087-.011 3.801 3.801 0 01-.7 1.865c-.144.181-.31.345-.492.49.025 1.633.469 2.23 2.315 2.838 1.728.569 2.543.966 2.687 2.429a.472.472 0 01-.47.519H5.596a.472.472 0 01-.47-.52c.145-1.462.96-1.86 2.687-2.428z"
  }));
};

var _default = (0, _react.forwardRef)(User);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(User, "User", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/User.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/User.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();